import React, { useEffect, useState } from 'react';
import { Button } from '@fiverr-private/button';
import { I18n } from '@fiverr-private/i18n-react';
import { Collapse } from '@fiverr-private/transition';
import { Container } from '@fiverr-private/layout_components';
import { MAX_CONTENT_TRUNCATE_HEIGHT, MAX_CONTENT_TRUNCATE_LENGTH } from '../../../shared/const';

interface TruncateProps {
    children: string | TrustedHTML;
}

export const Truncate = ({ children }: TruncateProps) => {
    const ref: React.RefObject<any> = React.createRef();
    const [isTruncated, setIsTruncated] = useState(true);
    const [showControls, setShowControls] = useState(false);

    useEffect(() => {
        if (ref.current) {
            const content = ref?.current?.textContent?.length || 0;
            const longContent = content > MAX_CONTENT_TRUNCATE_LENGTH;
            setIsTruncated(longContent);
            setShowControls(longContent);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return (
        <>
            <Collapse in={!isTruncated} startingHeight={MAX_CONTENT_TRUNCATE_HEIGHT}>
                <Container position="relative" ref={ref}>
                    {children}
                    <Container
                        position="absolute"
                        height="10%"
                        width="100%"
                        style={{
                            position: 'absolute',
                            bottom: 0,
                            left: 0,
                            background: 'linear-gradient(to bottom, transparent, white)',
                            visibility: isTruncated ? 'visible' : 'hidden',
                            transition: 'visibility 0.1s ease-in-out',
                        }}
                    />
                </Container>
            </Collapse>
            {showControls && (
                <Container paddingTop="4">
                    <Button
                        variant="outline"
                        onClick={() => {
                            setIsTruncated((val) => !val);
                        }}
                    >
                        {isTruncated ? (
                            <I18n k="skill_page_perseus.truncate.see_more" />
                        ) : (
                            <I18n k="skill_page_perseus.truncate.see_less" />
                        )}
                    </Button>
                </Container>
            )}
        </>
    );
};
